document.addEventListener("DOMContentLoaded", function(){

  var swipersocial = new Swiper(".socialmedia__v2--linksinner", {
      slidesPerView: 1.2,
      spaceBetween: 16,
      scrollbar: {
        el: ".swiper-scrollbar.socialmedia",
        draggable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next.socialmedia",
        prevEl: ".swiper-button-prev.socialmedia",
      },
      breakpoints: {
          640: {
            slidesPerView: 1.2,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 2.7,
            spaceBetween: 16,
          },
        },
    });
    });



var playButton=document.querySelectorAll(".play__button");
var videoMain=document.querySelectorAll(".social__content--video video");


playButton.forEach(function(ele){



ele.addEventListener("click", function(){
var parentDiv = ele.closest(".socialpost--main");
var innerVideo=parentDiv.querySelector(".social__content--video video");
var videoPoster=parentDiv.querySelector('.image__poster')
innerVideo.play();
innerVideo.controls = true;
videoPoster.style.display="none";
})
})

videoMain.forEach(function(ele){
ele.addEventListener("pause",function(){
  var videoParent = ele.closest(".socialpost--main");
  var videoControls=videoParent.querySelector(".social__content--video");
  var videoControlsm=videoParent.querySelector(".social__content--video video");
  var videoPoster=videoControls.querySelector('.image__poster');
  videoControlsm.controls = false;
  videoPoster.style.display="block";
  
})
})




document.addEventListener("DOMContentLoaded", function(){


  var playButton=document.querySelectorAll(".play__button");
  var videoMain=document.querySelectorAll(".social__content--video video");
  
  console.log(playButton)
  playButton.forEach(function(ele){
  
  
  
  ele.addEventListener("click", function(){
  
    var parentDiv = ele.closest(".video__iconvideo--main");
    var innerVideo=parentDiv.querySelector(".social__content--video video");
    var videoPoster=parentDiv.querySelector('.image__poster')
    innerVideo.play();
    innerVideo.controls = true;
    videoPoster.style.display="none";
  })
  })
  console.log(videoMain)
  videoMain.forEach(function(ele){
    ele.addEventListener("pause",function(){
      var videoParent = ele.closest(".video__iconvideo--main");
      var videoControls=videoParent.querySelector(".social__content--video video");
      var videoPoster=videoParent.querySelector('.image__poster');
      videoControls.controls = false;
      videoPoster.style.display="block";
  })
  })
  
  })
  


  document.addEventListener("DOMContentLoaded", function () {
    let swipericons = null;
  
    function initSwiperIfNeeded() {
      if (window.innerWidth < 873 && !swipericons) {
        swipericons = new Swiper(".main__iconsv2--inner", {
          slidesPerView: 1,
          spaceBetween: 16,
          scrollbar: {
            el: ".swiper-scrollbar.icons",
          },
          navigation: {
            nextEl: ".swiper-button-next.vcategory",
            prevEl: ".swiper-button-prev.vcategory",
          },
        });
      }
    }
  
    // Check on page load
    initSwiperIfNeeded();
  
    // Check again on resize
    window.addEventListener("resize", function () {
      initSwiperIfNeeded();
    });
  });
